import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
  className?: string;
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  className,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`financial-tabpanel-${index}`}
      aria-labelledby={`financial-tab-${index}`}
      className={`tab-panel ${className || ''}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
};
